import type { WebTemplateKey } from '@generalTypes/apiTypes';
import { selectTitleNode } from '@newStore/documentUI/transformContent/genericSelectors';
import { loadSharedItemFacets } from '@newStore/externalData/sharedItemFacets';
import { referenceFrames } from '@newStore/referenceFrames/referenceFrames';
import { loadReferenceFrame } from '@newStore/referenceFrames/referenceFramesState';
import { selectValidateChildrenAreRequired } from '@newStore/validation/validationRules/childrenAreRequired';
import { selectCurriculumThemesValidation } from '@newStore/validation/validationRules/curriculumThemesConsistencyValidation';
import { NodeType, RequiredType, type RootNodeConfig } from '@nodeTypeConfig/configTypes';
import { authorsComponent } from '@nodeTypeConfig/helpers/editComponents/authorsComponent';
import { curriculumSelectorComponent } from '@nodeTypeConfig/helpers/editComponents/curriculumSelector';
import { proThemeAudienceTab } from '@nodeTypeConfig/helpers/editComponents/proThemeAudienceTab';
import { webFacetsPlaceHolderComponent } from '@nodeTypeConfig/helpers/editComponents/proWebFacetComponent';
import { publishComponent } from '@nodeTypeConfig/helpers/editComponents/publishComponent';
import { titleComponent } from '@nodeTypeConfig/helpers/editComponents/titleComponent';
import constants from '../../../../reduxLoop/constants/constants';
import { leerplanSitesThemeComponent } from './leerplansitesGenericConfigProps';

export const SHARED_ATTACHMENTS_GROUP: RootNodeConfig = {
  nodeSelector: selectTitleNode,
  validationRules: [selectValidateChildrenAreRequired, selectCurriculumThemesValidation],
  information: {
    definiteArticle: true,
    single: 'Achtergronddocument (leerplansites so)',
    plural: 'Achtergronddocumenten (leerplansites so)',
    icon: require('../../../../../img/icons/shared-attachments-group.svg'),
    category: 'LEERPLANSITES_SO',
  },
  onLoadActions: [
    loadReferenceFrame({ referenceFrame: referenceFrames.pro }),
    loadSharedItemFacets({
      matchingParams: {
        themesMatchingOnRoot: { referenceFrameKey: constants.dienstverleningKovKey },
        'webPage.template': '6a090cca-c380-4248-8722-2951431018a9' as WebTemplateKey, // DOWNLOAD_PAGE
        $$includeWebPages: true,
      },
    }),
  ],
  websiteHref: null,
  createModal: {
    authors: {
      addUser: true,
      required: true,
    },
  },
  tocTypes: [],
  buildingBlocks: [
    {
      type: NodeType.ATTACHMENT,
    },
    {
      type: NodeType.GLOBAL_DOCUMENT,
    },
  ],
  edit: [
    titleComponent,
    publishComponent,
    {
      ...authorsComponent,
      required: RequiredType.ERROR,
    },
    {
      ...leerplanSitesThemeComponent,
      customRequiredMessage:
        'Je moet een <strong>leerplanthema</strong> invullen. Anders verschijnt dit item niet in een bijlagegroep.',
    },
    curriculumSelectorComponent,
    webFacetsPlaceHolderComponent,
  ],
  audienceTab: proThemeAudienceTab,
  isCreatable: true,
  isSearchable: true,
  isCloneable: true,
  allowSuggestions: false,
};
